import { EventStream } from 'Roblox';
import { outfitClickEventName, outfitWearEventName, outfitEventType} from '../constants/avatarOutfitEventConstants';

export function sendOutfitClickEvent(userOutfitId) {
    if (EventStream) {
        EventStream.SendEventWithTarget(
            outfitClickEventName,
            outfitEventType,
            { 
                userOutfitId: userOutfitId
            },
            EventStream.TargetTypes.WWW
        );
        
    }
}

export function sendOutfitWearEvent(userOutfitId, success) {
    if (EventStream) {
        EventStream.SendEventWithTarget(
            outfitWearEventName,
            outfitEventType,
            { 
                userOutfitId: userOutfitId,
                success: success
            },
            EventStream.TargetTypes.WWW
        );
    }
}
